import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {EffectsModule} from '@ngrx/effects';
import {AuthenticationEffects} from '@iw-shared/store/effects/authentication.effects';
import {UserEffects} from '@iw-shared/store/effects/user.effects';
import {ChangeDetectionEffects} from '@iw-shared/store/effects/change-detection.effects';
import {MetaReducer, StoreModule} from '@ngrx/store';
import {appReducers} from '@account/store/reducers/app.reducer';
import {environment} from '@account-environments/environment';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {localStorageSyncReducer} from '@iw-shared/core/functions/ngrx-local-storage-sync';
import {AppInitStorageService} from '@account/core/services/app-init-storage.service';
import {GlobalErrorHandler} from '@iw-shared/core/classes/error-handler';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CommonModule, NgOptimizedImage, registerLocaleData} from '@angular/common';
import {PageAuthenticationModule} from "@account/_pages/authentication/page-authentication.module";
import {BrowserModule} from "@angular/platform-browser";
import {CoreModule} from "@iw-shared/core/core.module";
import {TokenInterceptor} from "@iw-shared/core/classes/token-interceptor";
import {ErrorInterceptor} from "@iw-shared/core/classes/error-interceptor";
import {DynamicDialogConfig} from "primeng/dynamicdialog";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MatNativeDateModule} from "@angular/material/core";
import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe);
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true}
];


@NgModule({
  declarations: [
    AppComponent,

  ],
  exports: [],
  bootstrap: [AppComponent], imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    PageAuthenticationModule,
    MatNativeDateModule,

    EffectsModule.forRoot([AuthenticationEffects, UserEffects, ChangeDetectionEffects]),
    StoreModule.forRoot(appReducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictStateSerializability: true,
        strictActionSerializability: true
      }
    }),
    !environment.production ? StoreDevtoolsModule.instrument({
      maxAge: 20
    }) : [],
    NgOptimizedImage,
    CoreModule
  ], providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    DynamicDialogConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: (appInit: AppInitStorageService) => () => appInit.init(),
      deps: [AppInitStorageService],
      multi: true
    },
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    httpInterceptorProviders,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
